/**
 * 入口：
 * * trip
 * * trip-map
 * * route
 *
 * * select-attraction
 * * search-attraction
 *
 * * edit-trip
 * * search-hotel
 */

import React from 'react';
import { connect } from 'react-redux';
import render from '../render';
import './index.css';

import { LoadingScreen } from '../../components/Loading';
import toast from '../../components/toast';
import StarScore from '../../components/StarScore';
import Map from './Map';
import Footer from './Footer';
import DownloadBar from './DownloadBar';

import { getQuery, open } from '../../utils/url';
import { TYPE } from '../../utils/type';
import * as async from '../../utils/async';
import * as tripHelper from '../../utils/tripHelper';
import * as navigator from '../../utils/navigator';
import * as actionsPoi from '../../store/actions/poi';
import * as actionsTrip from '../../store/actions/trip';
import Clipboard from 'clipboard';
import { supportSdk } from '../../utils/getPlatform';


// 头部渐隐渐现
supportSdk() && zzc.call('base_setTopNavbarFadeIn', {
  startOffset: 140, // 开始呈现位置
  endOffset: 240, // 结束呈现位置
  success: function (response) {
  }
});

// 左上角返回键样式
supportSdk() && zzc.call('base_customNavbarLeftButton', {
  type: 'back_btn',
  imageUrl: 'back',
  topImageUrl:'back_white',
  text: '返回',
});


const query = getQuery();


class Poi extends React.Component {
  render() {
    let { poi, trip, city } = this.props;

    if (async.isLoading(poi.status)) {
      return (<LoadingScreen />);
    }

    if (async.isFailure(poi.status)) {
      // TODO
    }

    poi = poi.data;
    if (!poi) return false;
    console.log(poi);

    let { pic, cn_name, en_name, grade, address, lat, lng, tel, open_time, desc, average_prices, tags, stay_agv, wiki_url, good_desc } = poi.info;

    tags instanceof Array || (tags = []);
    average_prices instanceof Array || (average_prices = []);

    // 处理整体页面高度不足的情况
    this.handleShortBodyHeight && this.handleShortBodyHeight();

    return (
      <div id="poi"
        onClick={this.handleClickBody}
        onTouchMove={this.handleClickBody}>
        <div className="main">

          <section>
            <div className="banner">
              <div className="banner-entity" style={{backgroundImage: `url(${pic.full || pic.big || pic.small_s})`}}></div>
            </div>
            <div className="main-info">
              <div className="primary-name">{cn_name}</div>
              <div className="secondary-name">{en_name}</div>
              {
                grade > 0 &&
                <StarScore score={grade} />
              }
              {
                !!good_desc &&
                <div className="good-desc">{good_desc}</div>
              }
              {
                !!(tags.length || average_prices.length) &&
                <div className="tags-wrap">
                  {
                    !!(tags.length) &&
                    <span className="tags">{tags.join('/')}</span>
                  }
                  {
                    average_prices[0] &&
                    <span className="price">人均{average_prices[0]}
                      {
                        average_prices[1] &&
                        <b>({average_prices[1]})</b>
                      }
                    </span>
                  }
                </div>
              }
            </div>
          </section>

          <section>
            <div className="subfield address">
              <div className="left">地址</div>
              <div className="right">
                <div onClick={this.handleClickAddress}>
                  <address>{address}</address>
                  <div className="geolocation">
                    {latLngDecimalToStandard(lat, 'lat') + ', ' + latLngDecimalToStandard(lng, 'lng')}</div>
                </div>
                {
                  !/create|edit|select-attraction/.test(TYPE) &&
                  <span onClick={this.handleNavigate}>
                    <i className="icon icon-navigate"></i>
                    <b>导航</b>
                  </span>
                }
              </div>
            </div>
            <Map
              poi={poi}
              onClick={this.handleClickMap} />
            {
              open_time &&
              <div className="subfield">
                <div className="left">营业</div>
                <div className="right">{open_time}</div>
              </div>
            }
            {
              poi.poi_type === 'attraction' && stay_agv &&
              <div className="subfield">
                <div className="left">时长</div>
                <div className="right">建议游玩{tripHelper.getPoiTravelTime(poi)}小时</div>
              </div>
            }
            {
              tel &&
              <div className="subfield">
                <div className="left">电话</div>
                <a href={`tel:${tel}`} className="tel">{tel}</a>
              </div>
            }
          </section>

          {
            !!(desc || wiki_url) &&
            <section>
              <div className="subfield">
                <div className="left">简介</div>
              </div>
              <div className="desc-content">
                <div dangerouslySetInnerHTML={{__html: desc}}></div>
                {
                  wiki_url && <a className="wiki-entrance" href={wiki_url.url}>[维基百科]</a>
                }
              </div>
            </section>
          }
        </div>

        <Footer
          poi={poi}
          trip={trip}
          city={city} />
        <DownloadBar />
      </div>
    );
  }

  componentDidMount() {
    this.fetchPoi();
    this.fetchTrip();

    let _this = this;

    /**
     * 粘贴板工具初始化
     */
    let clipboard = new Clipboard('.clipboard-trigger', {
      text: function(trigger) {
        let dataKey = trigger.getAttribute('data-key');
        let result = ' ';
        let info = _this.props.poi.data.info;
        if (dataKey === 'latlng') {
          result = latLngDecimalToStandard(info.lat, 'lat') + ', ' + latLngDecimalToStandard(info.lng, 'lng');
        } else {
          result = info['address'];
        }
        return result;
      }
    });
    clipboard.on('success', e => {
      toast('复制成功');
    });
    clipboard.on('error', err => {
      console.log(err)
    });
  }

  handleShortBodyHeight() {
    this.handleShortBodyHeight = null;

    setTimeout(() => {
      // body高度不超过屏幕240以上的话，直接不显示
      if (document.body.scrollHeight - window.screen.height < 240) {
        console.log('bodyHeight not enough');
        supportSdk() && zzc.call('base_setTopNavbarFadeIn', {
          startOffset: 300,
          endOffset: 300,
          success: function (response) {}
        });
      }
    }, 10)

  }

  isAttraction() {
    let {poi} = this.props;
    return tripHelper.type.isAttraction(poi.data);
  }

  fetchPoi() {
    let {poi} = this.props;

    if (!poi.data) {
      actionsPoi.getPoi(query.poi_uid, query.trip_id).catch(function (err) {
        toast(err.message);
      });
    }
  }

  fetchTrip() {
    let {trip} = this.props;

    if (query.trip_id && !trip) {
      actionsTrip.getTrip(query.trip_id).catch(function (err) {
        toast(err.message);
      });
    }
  }

  handleNavigate = () => {
    let {poi} = this.props;
    navigator.mapNavigation(poi.data);
  }

  handleClickMap = () => {
    open('/m/v2/?m=render&page=poi-location', {
      poi_uid: query.poi_uid
    });
  }

  handleClickBody = () => {
    this.clipboardMenu.isShow && this.clipboardMenu.hide();
  }

  handleClickAddress = e => {
    e.stopPropagation();
    e.preventDefault();

    if (this.clipboardMenu.isShow) {
      this.clipboardMenu.hide();
    } else {
      let t = e.currentTarget;
      let top = t.offsetTop,
          width = t.clientWidth,
          left = t.offsetLeft + width / 2;

      let info = this.props.poi.data.info;
      let items = [];

      if (info.address) {
        items.push({
          name: '复制地址',
          key: 'address'
        })
      }

      if (info.lat && info.lng) {
        items.push({
          name: '复制经纬度',
          key: 'latlng'
        })
      }

      this.clipboardMenu.show({
        left, top, items
      });
    }
  }

  clipboardMenu = (function () {
    let el = document.createElement('div');
    el.className = 'bubble-menu';
    el.innerHTML = '';
    el.addEventListener('click', () => {
      controller.hide();
    });

    let style = document.createElement('style');
    style.innerHTML = `
      .bubble-menu {
        display: none; position: absolute; top: 0; left: 0;
        white-space: nowrap; border-radius: .1rem;
        font-size: 12px; color: #fff; background-color: rgba(0,0,0,.7);
        transform: translate(-50%, -3em);
      }
      .bubble-menu::after {
        content: ''; position: absolute; left: 50%; top: 100%;
        width: 0; height: 0;
        border-top: 8px solid rgba(0,0,0,.7);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        transform: translate3d(-50%, 0, 0);
      }
      .bubble-menu span {
        position: relative;
        display: inline-block;
        padding: 6px 2em;
      }
      .bubble-menu span::after {
        content: '|';
        position: absolute;
        right: 0;
      }
      .bubble-menu span:last-child::after {
        content: '';
      }`
    document.body.appendChild(style);
    document.body.appendChild(el);

    let controller = {
      el,
      isShow: false,
      show(params) {
        let left = params.left || 0;
        let top = params.top || 0;
        let items = params.items || [];

        let _html = '';
        items.forEach(item => {
          _html += `<span class="clipboard-trigger" data-key="${item.key}">${item.name}</span>`;
        });

        el.innerHTML = _html;
        el.style.left = Math.round(left) + 'px';
        el.style.top = Math.round(top) + 'px';
        el.style.display = 'block';
        this.isShow = true;
      },
      hide() {
        el.style.display = 'none';
        this.isShow = false;
      }
    };

    return controller;
  })()
}




const PoiContainer = connect(function (state) {
  let cityMap = state.entities.cities;
  let poiMap = state.entities.pois;
  let tripMap = state.entities.trips;
  let props = {
    poi: { ...state.pages.poi }
  };

  let poi_uid = query.poi_uid;
  let poi = poiMap[query.poi_uid];

  // 收藏夹poi，自定义点除外，强制用线上数据，产品说详情少，数据丢失
  if (poi && poi.favorites_id && tripHelper.typeOfPoiUid(poi_uid) !== 'custom_save') {
    poi = undefined;
  }

  // 优先使用缓存
  if (poi && cityMap[poi.info.city]) {
    props.poi = {
      status: 'success',
      message: '缓存',
      data: poi
    };
    props.city = cityMap[poi.info.city];
  } else if (props.poi.data) {
    props.poi.data = poiMap[poi_uid];

    let city = props.poi.data && props.poi.data.info && props.poi.data.info.city;
    props.city = cityMap[city];
  }


  let trip_id = query.trip_id;

  if (trip_id) {
    switch (TYPE) {
      case 'create':
        props.trip = state.editingTrip.start;
        break;
      case 'edit':
        props.trip = state.editingTrip.editTrip;
        break;
      case 'select-attraction':
        props.trip = state.editingTrip.selectAttraction;
        break;
      default:
        props.trip = tripMap[trip_id];
    }
  }

  return props;
})(Poi);


render(PoiContainer);





function latLngDecimalToStandard(num, type) {
  num = Number(num) || 0;
  let s = type === 'lat' ?
            (num >= 0 ? 'N' : 'S') :
            (num >= 0 ? 'E' : 'W');
  num = Math.abs(num);
  let r1 = Math.floor(num);
  let r2 = Math.floor((num - r1) * 60);
  let r3 = ((num - r1 - r2/60) * 3600).toFixed(3);


  return `${r1}°${r2}'${r3}"${s}`;
}





// WEBPACK FOOTER //
// ./src/pages/poi2/index.js